// Persisted per-group expand state (keyed by group label). Survives reloads so a
// user's opened/closed groups stick, independent of the auto-expand-active rule.
const KEY = 'eo:sidebar-expanded-groups';

export function loadGroupExpansion(): Record<string, boolean> {
  if (typeof window === 'undefined') return {};
  try {
    const parsed: unknown = JSON.parse(window.localStorage.getItem(KEY) ?? '{}');
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, boolean>) : {};
  } catch {
    return {};
  }
}

export function saveGroupExpansion(label: string, expanded: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(
      KEY,
      JSON.stringify({ ...loadGroupExpansion(), [label]: expanded }),
    );
  } catch {
    // storage disabled/full — expand state just won't persist
  }
}
